import { render, staticRenderFns } from "./DateInput.vue?vue&type=template&id=3bbc9c38&scoped=true&"
import script from "./DateInput.vue?vue&type=script&lang=ts&"
export * from "./DateInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbc9c38",
  null
  
)

export default component.exports